import { useEffect, useState } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

/**
 * Our own bound on initialisation: the SDK is given no `timeout`, so a request
 * that hangs never settles and callers that wait on this would wait forever.
 */
export const FLAG_SETTLE_TIMEOUT_MS = 5000;

/**
 * Whether LaunchDarkly has answered - with flag values, with a failure, or not
 * at all within the timeout. The provider sets the client on success and on
 * failure alike, so this turning true means no further flag values are coming,
 * not that any were read.
 */
export const useFeatureFlagsSettled = (): boolean => {
  const ldClient = useLDClient();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), FLAG_SETTLE_TIMEOUT_MS);

    return () => clearTimeout(timer);
  }, []);

  return Boolean(ldClient) || timedOut;
};
